import { Typography } from '@mui/material';

import { ErrorAlert } from '@/components';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from './Table';

export const FailedInvites = ({
  duplicateEmails,
}: {
  duplicateEmails: string[];
}) => {
  return (
    <TableContainer sx={{ maxHeight: 300 }}>
      <Table size="small" aria-label="Failed Invites">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="body3SemiBold">EMAIL</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body3SemiBold">ERROR</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {duplicateEmails.map((email, index) => (
            <TableRow key={index}>
              <TableCell>
                <Typography variant="body2">{email}</Typography>
              </TableCell>
              <TableCell>
                <ErrorAlert error="account already exists" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
